import { NgModule } from '@angular/core';
import { AccordionItemComponent } from './accordion-item/accordion-item.component';
import { AccordionComponent } from './accordion.component';
import { CommonModule } from '@angular/common';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { PipesModule } from '../../pipes/pipes.module';

const components = [AccordionItemComponent, AccordionComponent];

@NgModule({
  declarations: components,
  exports: components,
  entryComponents: components,
  imports: [CommonModule, AngularSvgIconModule, PipesModule]
})
export class AccordionModule {}

export { AccordionItemComponent, AccordionComponent };

export * from './accordion.types';
